// Translation: English > Generic
const generic = Object.freeze({
	accountSettings: 'Account settings',
	active: 'Active',
	all: 'All',
	apiCall: 'API call',
	apiCall_one: 'API call',
	apiCall_other: 'API calls',
	apiCalls: 'API calls',
	apiCallWithCount_one: '{{count}} API call',
	apiCallWithCount_other: '{{count}} API calls',
	bestWithCount: 'Best {{count}}',
	billing: 'Billing',
	billingItemTypeItems: {
		ASSET_HOSTING: 'Asset hosting',
		ASSET_HOSTING_REFUND: 'Asset hosting refund',
		ASSET_REFUND: 'Asset refund',
		ASSET_TRAINING_REFUND: 'Asset training refund',
		ASSET_USAGE: 'Asset usage',
		ASSET_USAGE_REFUND: 'Asset usage refund',
		AUTO_TOP_UP: 'Auto top-up',
		BENCHMARK_OVERHEAD: 'Reporting and scoring service fee',
		EXPIRABLE_CREDIT: 'Expirable credit',
		OTHER: 'Service fee',
		OVERHEAD: 'Service fee',
		OVERHEAD_FINETUNE_TRAINING: 'FineTune service fee',
		PAY_OUT: 'Payout',
		RESERVE_ASSET_USAGE: 'Reserve asset usage',
		SERVICE_ASSET_USAGE: 'Service asset usage',
		SUBSCRIPTION: 'Subscription',
		SUPPLIER_FINETUNE_TRAINING: 'FineTune training supplier fee',
		TOP_UP: 'Top-up',
		TRANSFER: 'Transfer',
		TRIAL_TOP_UP: 'Trial top-up',
		UNKNOWN: 'Unknown transaction',
		UNSUBSCRIBE: 'Unsubscription'
	},
	billingTypeItems: {
		service: 'Service',
		transfer: 'Transfer'
	},
	by: 'by {{reference}}',
	byWithItem: '{{item}} by {{reference}}',
	chartTypeItems: {
		barChart: 'Bar chart',
		boxPlotChart: 'Box plot'
	},
	collected: 'Collected',
	comingSoon: 'Coming soon',
	comparisonTypeItems: {
		contains: 'Contains',
		different: 'Different',
		differentWithValue: '≠ {{value}}',
		equal: 'Equal',
		equalWithValue: '= {{value}}',
		greaterThan: 'Greater than',
		greaterThanOrEqual: 'Greater than or equal',
		greaterThanOrEqualWithValue: '>= {{value}}',
		greaterThanWithValue: '> {{value}}',
		in: 'In',
		lessThan: 'Less than',
		lessThanOrEqual: 'Less than or equal',
		lessThanOrEqualWithValue: '<= {{value}}',
		lessThanWithValue: '< {{value}}'
	},
	configuration: 'Configuration',
	creationDate: 'Creation date',
	default: 'Default',
	description: 'Description',
	duration: 'Duration',
	error: 'Error',
	extensions: 'Extensions',
	false: 'False',
	free: 'Free',
	generalSettings: 'General settings',
	id: 'ID',
	integrations: 'Integrations',
	lastUpdate: 'Last update',
	license: 'License',
	link: 'Link',
	loading: 'Loading',
	membershipPlan: 'Membership plan',
	membershipPlans: 'Membership plans',
	modificationDate: 'Modification date',
	name: 'Name',
	new: 'New',
	none: 'None',
	noResults: 'No results',
	notSelected: 'Not selected',
	off: 'Off',
	on: 'On',
	optional: 'Optional',
	owner: 'Owner',
	plainText: 'Plain text',
	preferences: 'Preferences',
	preview: 'Preview',
	price: 'Price',
	profile: 'Profile',
	request: 'Request',
	required: 'Required',
	result: 'Result',
	roleItems: {
		admin: 'Admin',
		member: 'Member',
		owner: 'Owner'
	},
	saved: 'Saved',
	settings: 'Settings',
	sortingMethodItems: {
		dateNew: 'Newest',
		dateOld: 'Oldest',
		updateLast: 'Most recent',
		popularity: 'Popular',
		priceHigh: 'High price',
		priceLow: 'Low price'
	},
	status: 'Status',
	step: 'Step {{number}}',
	tag: 'Tag',
	tag_one: 'Tag',
	tag_other: 'Tags',
	tags: 'Tags',
	tagWithCount_one: '{{count}} tag',
	tagWithCount_other: '{{count}} tags',
	team: 'Team',
	teamMembers: 'Members',
	teamSettings: 'Team settings',
	totalDuration: 'Total duration',
	true: 'True',
	type: 'Type',
	unavailable: 'Unavailable',
	unknown: 'Unknown',
	unnamed: 'Unnamed',
	updatedAt: 'Updated at',
	volume: 'Volume',
	worstWithCount: 'Worst {{count}}'
})

// Export
export default generic
